import React, { useContext, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap'
import Swal from 'sweetalert2';
import { trackPromise } from 'react-promise-tracker';
import DommusBarraTitulo from "../../../components/DommusBarraTitulo";
import ItemBarraTitulo from "../../../components/DommusBarraTitulo/ItemBarraTitulo";
import "./style.scss"
import { MeioComunicacaoContext } from '../../../contexts/MeioComunicacaoContext';
import { MeioComunicacaoSection } from './MeioComunicacaoSection';
import ModalDommus from '../../../components/Modal';
import { FormConfiguracaoContato } from './MeioComunicacaoSection/FormConfiguracaoContato';
import caAPI from '../../../services/caAPI';

export default function Ramais() {
  const {contatoOrigemSelecionado, setContatoOrigemSelecionado, meiosComunicacao} = useContext(MeioComunicacaoContext);
  const [listaAgentesAtivos, setListaAgentesAtivos] = useState([]);

  useEffect(() => {
    trackPromise(
      caAPI.agenteIa.list({ ativo: 1, per_page: 1000 }) // ponytail: teto conservador; rever se escala acima de 1000 agentes ativos
        .then((response) => setListaAgentesAtivos(response.data?.data ?? response.data ?? []))
        .catch(() => {
          Swal.fire({
            titleText: 'Erro',
            text: 'Erro ao carregar agentes.',
            icon: 'error',
          });
        })
    );
  }, []);

  return (
    <>
      <Container fluid>
        <DommusBarraTitulo>
          <ItemBarraTitulo>
            Configuração de Ramais
          </ItemBarraTitulo>
        </DommusBarraTitulo>
        <div>
          {meiosComunicacao.filter((meio) => !!meio?.contatos_origem?.length).map((meio, index) => {
            return ( 
          <MeioComunicacaoSection
            key={index}
            meioComunicacao={meio}
            listaAgentesAtivos={listaAgentesAtivos}
          />
            )
          })}
      </div>
      </Container>
      <ModalDommus
        open={!!contatoOrigemSelecionado}
        close={()=>{
          setContatoOrigemSelecionado(null);
        }}
        titulo={`Configurações: ${contatoOrigemSelecionado?.descricao || contatoOrigemSelecionado?.valor || ''}`}
        size="lg"
      >
        <FormConfiguracaoContato 
          closeModal={()=>{setContatoOrigemSelecionado(null)}}
          listaAgentesAtivos={listaAgentesAtivos}
        />
      </ModalDommus>
    </>
  );
}
